export enum PinAndSignatureProgress {
    Signature = 0,
    Pin,
    WitnessSignature,
    WitnessPin
}
